export default __webpack_public_path__ + "static/media/Neck.3d979dd9.svg";